module.exports = __webpack_public_path__ + "media/images/sp/specials/common/plan_house-91e978a971a56ef67dc870339b3f85da.jpg";